module.exports = __webpack_public_path__ + "static/img/中国具身智能创新.f14d305c.png";